import { HundredsChart } from "assets/icons";
import { ResetAction } from "components/actions";
import {
  DropdownSetting,
  InformationSetting,
  NumberInputSetting,
  RememberSettings,
} from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";

import { HundredsChartState, HundredsChartWidget } from "./HundredsChart";

export const InteractiveHundredsChart: WidgetType<HundredsChartState> = {
  name: "Hundreds Chart",
  component: HundredsChartWidget,
  icon: HundredsChart,
  showOnToolbar: true,
  sizing: {
    minWidth: 245,
    minHeight: 212,
    minAspectRatio: 1.15,
    maxAspectRatio: 1.15,
  },
  defaultState: {
    cellData: [],
    countBy: 1,
  },
  defaultSize: {
    aspectRatio: 1.15,
    widthPercentage: 40,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Colour in numbers and count in multiples. You can colour a number black to hide it for a guessing game.",
      },
    },
    start: {
      editor: NumberInputSetting,
      info: {
        label: "Start Number",
        minValue: -900,
        maxValue: 900,
        wholeNumbers: true,
      },
      defaultValue: 1,
    },
    rows: {
      editor: NumberInputSetting,
      info: {
        label: "Number of Rows",
        minValue: 2,
        maxValue: 10,
        wholeNumbers: true,
      },
      defaultValue: 10,
    },
    cols: {
      editor: NumberInputSetting,
      info: {
        label: "Number of Columns",
        minValue: 2,
        maxValue: 10,
        wholeNumbers: true,
      },
      defaultValue: 10,
    },
    order: {
      editor: DropdownSetting,
      info: {
        name: "Number Order",
        options: ["Ascending", "Descending"],
      },
      defaultValue: "Ascending",
    },
    countMethod: {
      editor: DropdownSetting,
      info: {
        name: "Counting Method",
        options: ["Click to count", "Automatic Counting"],
      },
      defaultValue: "Click to count",
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.hundredsChart,
        widgetDisplayName: "Hundreds Chart",
      },
    },
  },
  quickActions: {
    reset: ResetAction,
  },
};
